import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onShoeSizeFinderEvent,
  removeShoeSizeFinderEvent,
} from '@shared/event/events/shoe-size-finder'

const initShoeSizeFinderEvents = (Analytics: GooglePlugin) => {
  const shoeSizeFinderToken = onShoeSizeFinderEvent(({ action, label }) => {
    Analytics.event({
      event: 'shoe_size_finder',
      action,
      label,
    })
  })

  return () => {
    removeShoeSizeFinderEvent(shoeSizeFinderToken)
  }
}

export default initShoeSizeFinderEvents
